 <app-page>
  <ng-template #headerTpl>
    <app-header class="transparent negative" [transparent]="true"></app-header>
  </ng-template>

  <ng-template #mainTpl>
    <ng-container *ngIf="!(homeTrip.active$ | async); else inlineTrip">
    <div class="main-content">
      <div class="background">
        <img ngOptimizedImg [ngSrc]="'/assets/images/backpacker.webp'" fill priority>
        <div class="overlay"></div>

        <div class="hero">
          <h1 class="hero">
            <span class="hero-1"><ng-container i18n>Explore, Share and Earn. It’s That Simple!</ng-container></span>
            <br />
            <span class="hero-2"><ng-container i18n>Don't put limits on adventures!</ng-container></span>
          </h1>
        </div>

        <app-search-bar [showTripEntry]="true" [initialSearch]="homeTrip.singleSearch" (tripRequested)="openTrip($event)"></app-search-bar>
      </div>

      <div class="left">
        <div class="prompt">
          <app-explore (propertiesChange)="update($event)"></app-explore>
          <app-explore-mobile></app-explore-mobile>
          <button type="button" class="mobile-trip-entry" (click)="openTrip()">
            <span class="mobile-trip-icon" aria-hidden="true">↗</span>
            <span><strong i18n="@@homeMoreThanOneStop">More than one stop?</strong><span i18n="@@homePlanMultiStop">Plan a multi-stop trip</span></span>
            <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
      <div class="right">
        <div class="cards-wrapper">
          <ng-container *ngIf="(featured$ | async) as f;">
            <app-cards class="horizontal-mobile" [hostels]="f"></app-cards>
          </ng-container>
          <ng-template #skeleton>
            <app-cards class="horizontal-mobile" [hostels]="[]" [skeleton]="true"></app-cards>
          </ng-template>
        </div>
      </div>

      <div class="button-wrapper">
        <a class="btn btn-theme btn-large" [href]="pwaUrl" target="_blank" >
          <span style="display: flex; align-items: center;">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Group 136">
                <path id="Vector" d="M9.48927 17.0779C13.9566 17.0779 17.5781 13.4563 17.5781 8.98893C17.5781 4.52153 13.9566 0.899994 9.48927 0.899994C5.0219 0.899994 1.40039 4.52153 1.40039 8.98893C1.40039 13.4563 5.0219 17.0779 9.48927 17.0779Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Vector_2" d="M19.6005 19.1L15.2021 14.7016" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
          </span>
          <span>
            <ng-container i18n>Explore all hostels</ng-container>
          </span>
        </a>
      </div>
    </div>

    <app-journeys-landing-section (planTrip)="openTrip($event)"></app-journeys-landing-section>

    <div #section2></div>
    <ng-container *ngIf="isBrowser">
      @defer {
        <app-first-section-landing></app-first-section-landing>
      }
      @defer {
        <app-credits-section></app-credits-section>
      }
      @defer {
        <app-ambassador-landing-section></app-ambassador-landing-section>
      }

      <div #section5></div>

      <div #section6></div>
      @defer (on viewport(section5)) {
        <div class="section_6">
          <div class="section-header font-secondary">
            <ng-container i18n>Travel better.</ng-container>
          </div>
          <h2 class="section-content">
            <ng-container i18n>Discover a world of possibilities with Hostel Hop. Our platform offers a wealth of innovative features, from money-saving rewards to interactive maps and much more. Explore, book, and connect like never before with Hostel Hop.</ng-container>
          </h2>
        </div>
      }

      <div #section7></div>
      @defer (on viewport(section6)) {
        <app-promo-scroller></app-promo-scroller>
      }

      <div #section8></div>
      @defer (on viewport(section8)) {
        <app-channel-managers></app-channel-managers>
      }

      <div class="cta-wrapper">
        <app-qr-code-cta></app-qr-code-cta>
      </div>

      @defer (on viewport(section8)) {
        <app-download></app-download>
      }
    </ng-container>

    </ng-container>
    <ng-template #inlineTrip><app-home-trip-planner [initialSearch]="homeTrip.seed" (exit)="closeTrip()" /></ng-template>
  </ng-template>
 </app-page>
